import * as React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ApiScopeNotice } from '../components/ApiScopeNotice.js';
import { Shell } from '../components/Shell.js';
import { AuthErrorPage, LoginPage, MfaPage } from '../features/auth/AuthPages.js';
import { RequireApiSession } from '../features/auth/AuthSession.js';
import { CatalogPage } from '../features/catalog/CatalogPage.js';
import { MappingsPage } from '../features/mappings/MappingsPage.js';
import { AccessRequestsPage, CommercialAccessPage, IntegrationsPage, PlatformAccessPage, SupportAccessPage, TenantsPage } from '../features/platform/PlatformPages.js';
import { SuppliersPage } from '../features/suppliers/SuppliersPage.js';
import { UsersPage } from '../features/users/UsersPage.js';
import { repository } from '../repositories/index.js';

const tenant = (page: React.ReactElement) => <RequireApiSession><Shell variant="tenant">{page}</Shell></RequireApiSession>;
const platform = (page: React.ReactElement) => <Shell variant="platform">{page}</Shell>;
const support = (page: React.ReactElement) => <Shell variant="support">{page}</Shell>;
const apiOnlyNotice = (title: string) => <ApiScopeNotice title={title} />;

export function AppRoutes() {
  const apiMode = repository.mode === 'api';
  return (
    <Routes>
      <Route path="/auth/login" element={<LoginPage />} />
      <Route path="/auth/mfa" element={<MfaPage />} />
      <Route path="/auth/error" element={<AuthErrorPage />} />
      <Route path="/tenant/catalog" element={tenant(<CatalogPage mode="tenant" />)} />
      <Route path="/tenant/suppliers" element={apiMode ? tenant(apiOnlyNotice('Поставщики')) : tenant(<SuppliersPage mode="tenant" />)} />
      <Route path="/tenant/mappings" element={apiMode ? tenant(apiOnlyNotice('Сопоставления')) : tenant(<MappingsPage mode="tenant" />)} />
      <Route path="/tenant/users" element={apiMode ? tenant(apiOnlyNotice('Пользователи и доступ')) : tenant(<UsersPage mode="tenant" />)} />
      <Route path="/platform/tenants" element={apiMode ? apiOnlyNotice('Тенанты платформы') : platform(<TenantsPage />)} />
      <Route path="/platform/access-requests" element={apiMode ? apiOnlyNotice('Запросы на доступ') : platform(<AccessRequestsPage />)} />
      <Route path="/platform/commercial-access" element={apiMode ? apiOnlyNotice('Коммерческий доступ') : platform(<CommercialAccessPage />)} />
      <Route path="/platform/integrations" element={apiMode ? apiOnlyNotice('Интеграции поставщиков') : platform(<IntegrationsPage />)} />
      <Route path="/platform/support-access" element={apiMode ? apiOnlyNotice('Доступ поддержки') : platform(<SupportAccessPage />)} />
      <Route path="/platform/platform-access" element={apiMode ? apiOnlyNotice('Доступ платформы') : platform(<PlatformAccessPage />)} />
      <Route path="/support/catalog" element={apiMode ? apiOnlyNotice('Support Mode Catalog') : support(<CatalogPage mode="support-readonly" />)} />
      <Route path="/support/suppliers" element={apiMode ? apiOnlyNotice('Support Mode Suppliers') : support(<SuppliersPage mode="support-readonly" />)} />
      <Route path="/support/mappings" element={apiMode ? apiOnlyNotice('Support Mode Mappings') : support(<MappingsPage mode="support-readonly" />)} />
      <Route path="/support/users" element={apiMode ? apiOnlyNotice('Support Mode Users') : support(<UsersPage mode="support-readonly" />)} />
      <Route path="*" element={<Navigate to={apiMode ? '/auth/login' : '/tenant/catalog?query=R28003'} replace />} />
    </Routes>
  );
}
